module.exports = __webpack_public_path__ + "img/layer1-icon.d9a2ac37.png";